// src/components/auth/components/ImgOlslm/ImgOlslmQ4.tsx
import React from "react";
import { TreeSelect } from "antd";
import { loginImages } from "../../constants/LoginImg";

const { TreeNode } = TreeSelect;

const ImgOlslmQ4: React.FC = () => {
  return (
    <TreeNode title="Q4" key="4-4-4" value="4-4-4" disabled>
      <TreeNode
        title="967.3399"
        key={loginImages.images[2].url}
        value={loginImages.images[2].url}
        imageUrl={loginImages.images[2].url}
      />
      <TreeNode
        title="968.3399"
        key={loginImages.images[3].url}
        value={loginImages.images[3].url}
        imageUrl={loginImages.images[3].url}
      />
      <TreeNode
        title="969.3399"
        key={loginImages.images[4].url}
        value={loginImages.images[4].url}
        imageUrl={loginImages.images[4].url}
      />
      <TreeNode
        title="970.3399"
        key={loginImages.images[5].url}
        value={loginImages.images[5].url}
        imageUrl={loginImages.images[5].url}
      />
      <TreeNode
        title="1702.365.3401"
        key={loginImages.images[7].url}
        value={loginImages.images[7].url}
        imageUrl={loginImages.images[7].url}
      />
    </TreeNode>
  );
};

export default ImgOlslmQ4;